class HeroBundleController extends HTMLElement {
  constructor() {
    super();
    
    this.activeIndex = 0;

    this.addEventListener('click', (e) => this.handleClick(e));
  }

  connectedCallback() {
    setTimeout(() => {
      this.setActiveIndex(0);
    }, 50);
  }

  handleClick(e) {
    const dot = e.target.closest('.hero-bundle-dot');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();

      const index = parseInt(dot.getAttribute('data-index'), 10);
      
      if (!isNaN(index)) {
        this.setActiveIndex(index);
      }

      return;
    }

    const title = e.target.closest('.hero-bundle-title-item');
    if (title) {
      e.preventDefault();
      e.stopPropagation();

      const index = parseInt(title.getAttribute('data-index'), 10);
      
      if (!isNaN(index)) {
        this.setActiveIndex(index);
      }
      
      return;
    }
  }

  setActiveIndex(index) {
    this.activeIndex = index;
    
    const indexElements = this.querySelectorAll('[data-index]');
    
    indexElements.forEach((el) => {
      const elIndex = parseInt(el.getAttribute('data-index'), 10);
      
      if (elIndex === index) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  }
}

if (!customElements.get('hero-bundle-controller')) {
  customElements.define('hero-bundle-controller', HeroBundleController);
}
